import { useState } from "react";
import { useContextLandingPages } from "src/Contexts/LandingPageContext/LandingPagesContext";
import { useLayoutMainContext } from "src/Contexts/MainLayoutContext";
import { api } from "src/shared/setup/API/api";

export const UseGetLandingPages = () => {
  const { handleGetAlert } = useLayoutMainContext();
  const { setListLandingPages } = useContextLandingPages();

  const [loading, setLoading] = useState(false);

  const handleGet = async () => {
    setLoading(true);

    api
      .get(`/landing-pages/all`)
      .then((res) => {
        setListLandingPages(res.data.data);
      })
      .catch((error) =>
        handleGetAlert({ message: error.response.data.message })
      )
      .finally(() => setLoading(false));
  };

  return { handleGet, loading };
};
